import { OPEN_MODAL } from '@iwModals/Modals.actions';
import { fork, put, takeLatest } from 'redux-saga/effects';

import { SHOW_PROCESING_PAYMENT_MODAL } from './ProcessingPaymentModal.actions';

export const processingPaymentModalSagasWorkers = [
    fork(showProcessingPaymentModal)
];

function* showProcessingPaymentModal() {
    yield takeLatest(SHOW_PROCESING_PAYMENT_MODAL, function* () {
        yield put({
            type: OPEN_MODAL,
            id: 'ProcessingPaymentModal'
        });
    });
}
